'use client';
import { useState } from 'react';

interface UseControllableStateParams<T> {
  defaultValue: T;
  valueFromProps: T | undefined;
  onChangeFromProps: ((x: T) => void) | undefined;
}

export function useControllableState<T>({
  defaultValue,
  valueFromProps,
  onChangeFromProps,
}: UseControllableStateParams<T>): [T, (x: T) => void] {
  const [internalValue, setInternalValue] = useState<T>(defaultValue);
  const isControlled = typeof valueFromProps !== 'undefined';
  const value = isControlled ? valueFromProps : internalValue;

  const setValue = (v: T) => {
    if (onChangeFromProps) {
      onChangeFromProps(v);
    }
    if (!isControlled) {
      setInternalValue(v);
    }
  };
  return [value, setValue];
}
